import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/data/categories";

export default function CtaBanner() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20soft%20gradient%20background%20in%20fresh%20sage%20green%20and%20warm%20cream%20tones%20with%20subtle%20geometric%20shapes%20and%20gentle%20light%2C%20minimal%20clean%20modern%20aesthetic%2C%20smooth%20airy%20texture%2C%20no%20text%2C%20high%20quality&width=1600&height=600&seq=usfans-cta-01&orientation=landscape"
          alt="USFans Spreadsheet call to action background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary-950/60"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="w-full max-w-3xl mx-auto flex flex-col items-center text-center py-20 md:py-24">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50">
            {t("ctaBanner.title")}
          </h2>
          <p className="mt-4 text-background-200 max-w-xl">{t("ctaBanner.subtitle")}</p>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="mt-7 inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line"></i>
            {t("ctaBanner.button")}
          </a>
        </div>
      </div>
    </section>
  );
}